import { Injectable } from "@angular/core";
import { WCPageDetailsResponseJSON } from "./../wcPage/WC-Page-Details-Response-JSON";
import { WCPageServiceRequestJSON } from "./../RequestTOJSON/WC-Page-Service-Request.JSON";
import { SurveyDeployerConfigResponseJSON } from "../surveyConfig/Survey-Deployer-Config-Response-JSON";
import { HTMLDisplayComponentRequestJSON } from "../RequestTOJSON/HTML-Display-Component-Request.JSON";
import { HTMLDisplayComponentJSON } from "./HTML-Display-Component-JSON";
import { HTMLComponentJSON } from "./HTML-Component-JSON";
import { SelectOption } from "./Select-Option-JSON";
import { DateValue } from "./../util/Date-Value";

@Injectable()
export class HTMLGenricComponent {
    // generalTo: any;
    Type: Number;
    name: string;
    value: string;
    sequence: number;
    viewable: boolean;
    editable: boolean;
    autoPopulate: boolean;
    mandatory: boolean;
    surveyUserColumnMasterID: number;
    autocomplete: boolean;
    size: number;
    autofocus: boolean;
    cols: number;
    rows: number;
    wrap: string;
    defaultValue: string;
    disabled: boolean;
    maxLength: number;
    placeholder: string;
    readOnly: boolean;
    required: boolean;
    indeterminate: boolean;
    checked: boolean;
    defaultChecked: boolean;
    max: number;
    min: number;
    step: number;
    length: number;
    selectedIndex: number;
    multiple: boolean;
    optionList: SelectOption[];
    htmlFor: String;
    selectedCheckBox: Number[];
	dateValue:DateValue;
    maxInt:Number;
    minInt:Number;
    
    constructor() {
        // this.generalTo = {

        // }
    }

}